import { useContextSelector } from "use-context-selector";
import {
  AmbientAudioContext,
  ViewerUIContext,
  ViewerPlacementContext,
  ViewerDrawingContext,
  ViewerHotspotFocusContext,
} from "./ViewerContexts";

export const useIsEditMode = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.isEditMode);

export const useSetIsEditMode = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setIsEditMode);

export const useHudVisible = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.hudVisible);

export const useSetHudVisible = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setHudVisible);

export const useAutoPlay = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.autoPlay);

export const useSetAutoPlay = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setAutoPlay);

export const useIsMinimizedMap = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx?.isMinimizedMap ?? true);

export const useSetIsMinimizedMap = () =>
  useContextSelector(
    ViewerUIContext,
    (ctx) => ctx?.setIsMinimizedMap ?? (() => {}),
  );

export const useSelectedFloorId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx?.selectedFloorId ?? null);

export const useSetSelectedFloorId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.handleSetSelectedFloorId);

export const useFocusedRoomId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.focusedRoomId);

export const useSetFocusedRoomId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setFocusedRoomId);

export const useHoveredRoomId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.hoveredRoomId);

export const useSetHoveredRoomId = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setHoveredRoomId);

export const useCaptureMode = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.captureMode);

export const useSetCaptureMode = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setCaptureMode);

export const useSphereCorrection = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.sphereCorrection);

export const useSetSphereCorrection = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setSphereCorrection);

export const useIsSceneBrowserVisible = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.isSceneBrowserVisible);

export const useSetIsSceneBrowserVisible = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.setIsSceneBrowserVisible);

export const useCameraAnglesRef = () =>
  useContextSelector(ViewerUIContext, (ctx) => ctx!.cameraAnglesRef);

export const useAmbientAudioRef = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.audioRef);

export const useAmbientAudioIsPlaying = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.isPlaying);

export const useAmbientAudioHasAudio = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.hasAudio);

export const useAmbientAudioToggle = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.toggle);

export const useAmbientAudioVolume = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.volume);

export const useAmbientAudioSetVolume = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.setVolume);

export const useAmbientAudioProgress = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.progress);

export const useAmbientAudioDuration = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.duration);

export const useAmbientAudioSeek = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.seek);

export const useAmbientAudioTrackCount = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.trackCount);

export const useAmbientAudioTrackIndex = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.trackIndex);

export const useAmbientAudioNext = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.next);

export const useAmbientAudioPrev = () =>
  useContextSelector(AmbientAudioContext, (ctx) => ctx!.prev);

export const usePlacementMode = () =>
  useContextSelector(ViewerPlacementContext, (ctx) => ctx!.placementMode);

export const useSetPlacementMode = () =>
  useContextSelector(ViewerPlacementContext, (ctx) => ctx!.setPlacementMode);

export const useIsDrawing = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx!.isDrawing);

export const useDrawingType = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx!.drawingType);

export const useSetDrawingType = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx!.setDrawingType);

export const useDrawPoints = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx?.drawPoints ?? []);

export const useSetDrawPoints = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx!.setDrawPoints);

export const useDrawEditingId = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx?.drawEditingId ?? null);

export const useSetDrawEditingId = () =>
  useContextSelector(ViewerDrawingContext, (ctx) => ctx!.setDrawEditingId);

export const useFocusedHsId = () =>
  useContextSelector(ViewerHotspotFocusContext, (ctx) => ctx!.focusedHsId);

export const useSetFocusedHsId = () =>
  useContextSelector(ViewerHotspotFocusContext, (ctx) => ctx!.setFocusedHsId);

export const useMovingHsId = () =>
  useContextSelector(ViewerHotspotFocusContext, (ctx) => ctx!.movingHsId);

export const useSetMovingHsId = () =>
  useContextSelector(ViewerHotspotFocusContext, (ctx) => ctx!.setmovingHsId);

export const useViewerUI = () => {
  const ctx = useContextSelector(ViewerUIContext, (ctx) => ctx);
  if (!ctx) throw new Error("useViewerUI debe usarse dentro de ViewerProvider");
  return ctx;
};
